import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import './VironNotice.css';
import { API_BASE_URL } from './config';
import { useState } from 'react';
import CryptoModal from './CryptoPopUp';
import CryptoPaymentModal from './CryptoPaymentPopUp';

function DrsPurchase() {

    let userId = localStorage.getItem('userId');
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        user_id: '',
        drs_btc_txn: '',
        drs_txc_txn: '',
        drs_usdc_txn: ''
    });
    const [isModalOpen, setModalOpen] = useState(false);
    const [isModalPaymentOpen, setModalOpenPayment] = useState(false);
    const [isModalPreLaunchOpen, setModalOpenPreLaunch] = useState(false);
    const submitSingleTxn = async (data) => {
        // at least one value will be there
        if (!data.drs_btc_txn && !data.drs_txc_txn && !data.drs_usdc_txn) {
            alert('Please enter valid  transaction ID.');
            return;
        }
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE_URL}/drs-payment`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(data),
            });

            const result = await res.json();
            if (res.ok) {
                alert(`Your crypto payment has been submitted!\nPlease click OK for an important NOTIFICATION.`);
                setFormData({
                    user_id: '',
                    drs_btc_txn: '',
                    drs_txc_txn: '',
                    drs_usdc_txn: ''
                });
                navigate('/member/paymentlandingpage');
            } else {
                alert('Error: ' + result.message);
            }
        } catch (err) {
            alert('Failed to submit payment.');
            console.error(err);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <Layout>
            <div className='container'>
                <div className="row">
                    <div className='col'>
                        <div className='mt-20'>
                            <h2 className='text-red text-center'>VIRON's Coveted: </h2>
                            <h2 className='text-red text-center'>DIRECT REFERRALS (“DRs”)<br />Now available for purchase!</h2>
                            {/* <p><i>*Expected availability is by end of December 2025.</i></p> */}
                            <hr className='mb-10 mt-20' />
                            <p className='text-center'><b>DRs details are as follows:</b></p>
                            <hr className='mt-10 mb-20' />
                            <ul className='additional'>
                                <li className='pl-30'>Each DR ordered generates for you: <b className='text-red'><u>1 DIRECT REFERRAL ("DR")</u></b> account.</li>
                                <li className='pl-30'>Each DR is a paid member who engages in TXC at the <u>minimum 1-Seat</u> - $995 level.</li>
                                <li className='pl-30'>The DR is then placed in your TXC downline, as if you personally enrolled the DR yourself!</li>
                            </ul>
                            <img class="content-center mt-20 mb-20" alt="satisfaction100per" src="assets/satisfaction100per.png" height={250} width={250} ></img>
                            <p className='text-center text-light-blue'>Each ("DR") purchased has a 100% Performance Guarantee.<br /><u>Get Your DRs Order Fulfilled Timely</u>…Or your Money Back!</p>
                            <hr className='mb-0 mt-10' />
                            <p className='text-red mt-5 mb-5 text-center'><b>DRs PRICE: <del>$499 each</del>, now only $298 each (Limited-Time-Only).</b></p>
                            <p className='mt-5 text-center'><i>*DR's price is subject to change without notice and in accordance with demand.</i></p>
                            <hr className='mt-10' />
                            <p className='mb-20 text-center'><b>The suggested usage of DRs and math for TXC is:</b></p>
                        </div>
                        <ul className='main-ul'>
                            <li className='mb-0'><b>Purchase 3 DRs x $298 each = <u>$894</u> cost for VIRON.</b></li>
                            <ul className='inner-list mt-0'>
                                <li className='mb-0'>When the DRs are placed, it will yield a <b className='text-light-blue'><u>$1,000</u></b> commission for you with <b className='text-light-blue'>TXC</b>. NOTE: Per the <b>TXC Binary Pay-Plan</b>, this situation can <u>only be achieved in the environment of VIRON</u> because VIRON systems will bring systematic SPILLS into everyone’s TXC Tree <u>ongoing</u>. Thus, one of your TXC binary legs will always be a “power leg”.</li>
                                <ul>
                                    <li style={{ listStyle: "disc" }}>Therefore, when your 3 DRs are placed into your TXC Tree…the $1k commission is realized, along with all the perks, including valuable Hash rate bonuses, etc.</li>
                                    <li style={{ listStyle: "disc" }}><b className='text-red'>*Every VIRON member can REPEAT this process by getting more DRs!</b> <i>*DRs are always subject to availability.</i></li>
                                    <ul>
                                        <li style={{ listStyle: "circle" }}><b><u>All DRs will want to buy more DRs</u>…</b>and so forth. Therefore, this situation can grow your TXC Business Center(s) at high velocity.</li>
                                        <li style={{ listStyle: "circle" }}>Please also keep in mind that in some situations, you would only need ONE DR to be qualified for the $1k commission from TXC! <i>*Only with the anticipated high-volume environment of VIRON, this situation can occur (more frequently).</i></li>
                                    </ul>
                                </ul>
                            </ul>
                        </ul>
                        <p className='text-red text-center mb-0'><strong>::: ::: :::</strong></p>
                        <h3 className='text-red text-center mt-0 paymentArea'><strong>PAYMENT AREA.</strong></h3>
                        <p className='text-red text-center mb-0 mt-0'><strong>::: ::: :::</strong></p>
                        <p className='text-center'>To complete your DRs order, please send <b className='text-red'><u>$298 (per each DR)</u></b> to any one of the following accepted Cryptocurrency Wallets of VIRON ESCROW:</p>
                        <hr className='mt-10 mb-10' />

                        <div style={{ display: "flex", justifyContent: "center" }}><img className='mt-10' src="https://viron.network/member/assets/usdc_image.png" alt="usdc_image" width="100px" /><img className='mt-10' src="https://viron.network/member/assets/Drs_usdc_scanner.png" alt="USDCscanner" width="125px" /></div>
                        <p className='text-center'><strong>USDC</strong> (ETH Network): </p>
                        <p className='text-center no_wordwrap'>0x072CdBB8C95aca261357d762Cd3F0C73DD735f11</p>
                        <div style={{ display: "flex", justifyContent: "center" }}><img className='mt-40' src="https://viron.network/member/assets/bitcoin.png" alt="bitcoin" width="100px" /><img className='mt-40' src="https://viron.network/member/assets/Drs_btc_scanner.png" alt="BTCscanner" width="125px" /></div>
                        <p className='text-center'><strong>BitCoin (BTC):</strong></p>
                        <p className='text-center no_wordwrap'>bc1qs62kg7xwk88dhjn6xm8arzjnjxgt3x9f3uuzu0</p>
                        <div style={{ display: "flex", justifyContent: "center" }}><img className='mt-40' src="https://viron.network/member/assets/texitcointpayment.png" alt="texitCoinScanner" width="100px" /><img className='mt-40' src="https://viron.network/member/assets/Drs_texitxoin_scanner.png" alt="texitCoinScanner" width="125px" /></div>
                        <p className='text-center'><strong>TEXITcoin (TXC):</strong></p>
                        <p className='text-center no_wordwrap'>txc1qyc6n22fjmf4huytwcr34pawj38hm9y8z6fcq8z</p>
                        <p className='text-center mt-0'><strong>:::</strong></p>
                        <p className='text-center'><strong className='text-red'>NOTE: When you make your crypto payment, please make sure to <u>copy</u> your Crypto <u>Transaction ID #</u>. Then enter it in the corresponding field below.</strong></p>

                        <div className="transaction-form-container">
                            <div className="crypto-form">
                                {[
                                    { id: 'drs_usdc_txn', label: 'USDC Blockchain Transaction ID#', placeholder: "Enter your USDC (ETH network) Blockchain Transaction ID#" },
                                    { id: 'drs_btc_txn', label: 'BTC Blockchain Transaction ID#', placeholder: "Enter your BTC Blockchain Transaction ID#" },
                                    { id: 'drs_txc_txn', label: 'TXC Blockchain Transaction ID#', placeholder: "Enter your TXC Blockchain Transaction ID#" },
                                ].map(({ id, label, placeholder }) => (
                                    <form
                                        key={id}
                                        className="form-row"
                                        style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}
                                        onSubmit={e => {
                                            e.preventDefault();
                                            // Only submit the current field
                                            const data = {
                                                user_id: userId,
                                                drs_usdc_txn: id === 'drs_usdc_txn' ? formData.drs_usdc_txn : '',
                                                drs_btc_txn: id === 'drs_btc_txn' ? formData.drs_btc_txn : '',
                                                drs_txc_txn: id === 'drs_txc_txn' ? formData.drs_txc_txn : '',
                                            };
                                            submitSingleTxn(data);
                                        }}
                                    >
                                        <label htmlFor={id} style={{ minWidth: 220 }}>{label}</label>
                                        <input
                                            type="text"
                                            id={id}
                                            name={id}
                                            value={formData[id]}
                                            onChange={handleChange}
                                            placeholder={placeholder}
                                            style={{ flex: 1, marginRight: 12 }}
                                        />
                                        <button type="submit">Submit</button>
                                    </form>
                                ))}
                            </div>
                        </div>
                        <p>When you click <b>“Submit”</b> to send your Crypto Transaction ID#, <b><u>the VIRON Admins will be notified and will escalate your DRs order.</u></b>  <b className='text-red'>YOU WILL RECEIVE PROPER NOTICE ACCORDINGLY, AT EACH STEP.</b></p>
                        <p className='text-center'><b><i>-The VIRON Administration</i></b></p>
                        <hr className='mt-20' />
                        <p className='text-center text-red mt-30 pb-10'><a style={{ cursor: 'pointer' }} onClick={() => setModalOpenPayment(true)}><strong><u>NEED HELP WITH CRYPTO PAYMENT?  CLICK HERE</u></strong></a></p>
                        <CryptoPaymentModal isOpen={isModalPaymentOpen} onClose={() => setModalOpenPayment(false)} />
                        <p className='text-center text-red pb-5'><a style={{ cursor: 'pointer' }} onClick={() => setModalOpen(true)}><u><strong>CRYPTO PAYMENT PREFERRED - WHY? CLICK HERE</strong></u></a></p>
                        <CryptoModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default DrsPurchase;
